export const selectDiscoverSearch = (state) => state.discoverSearch;
